// GENERATED by scripts/generate-app-version.mjs — do not edit by hand.
// Regenerated before every `nx build oms` (the generate-version target) and kept
// in sync with package.json. Env APP_VERSION wins so CI's --build-arg is honored.
export const APP_VERSION = '3.22.9';
